var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lolth-filter-field readonly"},[_c('p',{staticClass:"lolth-filter-field-column",staticStyle:{"width":"100%"}},[_vm._v(" "+_vm._s(_vm.format(_vm.filterCondition))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }